import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    deleteFilterPAFAA010Conditions,
    fetchInitialConditions,
    saveFilterPAFAA010Conditions,
    saveMatchingConditions,
} from '../../../redux/reducers/PAFAA010';
import { getPAAAA010resume, getPAFAA010search, postPAFAA010list, putPAAAA010Banner } from '../../../services/Api';
import Dropdown from '../../../shared/components/Dropdown';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';

import ResumeList from '../../../shared/components/ResumeList';
import { MENU_RESUME, MESSAGE } from '../../../shared/constants/app';
import { decodeToken, getDropdownValue } from '../../../utils';
import store from '../../../redux/store';

const PAFAA015 = () => {
    const [loading, setLoading] = useState(false);
    const [resumeLicenses, setResumeLicenses] = useState([]);
    const [resumeForms, setResumeForms] = useState([]);
    const [resumePositions, setResumePositions] = useState([]);
    const [resumePays, setResumePays] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState([]);
    const [resumeCareers, setResumeCareers] = useState([]);

    const [resumeClass, setResumeClass] = useState([]);
    const [resumeProvinces, setResumeProvinces] = useState([]);
    const [resumeCommunes, setResumeCommunes] = useState({});

    const [checkedValues, setCheckedValues] = useState({});
    const [resumeRegion, setResumeRegion] = useState({});

    const [results, setResults] = useState([]);
    const [size, setSize] = useState(50);
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [sortBy, setSortBy] = useState('ModDate');

    const [keywords, setKeywords] = useState([]);

    const dispatch = useDispatch();

    const savedConditions = useSelector(({ PAFAA010 }) => PAFAA010.savedPAFAA010Conditions);
    const [savedConditionsPopup, setSavedConditionsPopup] = useState(false);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (!loggedIn || decode?.authorities === 'ROLE_P') {
    //         alert('인재정보는 치과회원만 확인하실 수 있습니다.');
    //         navigate('/');
    //     }
    // }, [decode, navigate]);


    const popupRef = useRef(null);
    const [resumeBanner, setResumeBanner] = useState([]);
    const [dataConFig, setDataConFig] = useState({
        bannerConfig: '',
    });
    const getOptions = (name) => {
        const options = {
            ResumeLicense: resumeLicenses.map((license) => ({
                id: 'resumeLicenses_' + license.code,
                label: license.codeName,
                value: license.code,
            })),

            ResumeForm: resumeForms.map((form) => ({
                id: 'resumeForms_' + form.code,
                label: form.codeName,
                value: form.code,
            })),

            ResumePosition: resumePositions.map((position) => ({
                id: 'resumePositions_' + position.code,
                label: position.codeName,
                value: position.code,
            })),

            ResumePay: resumePays.map((pay) => ({
                id: 'resumePays_' + pay.code,
                label: pay.codeName,
                value: pay.code,
            })),

            ResumeCareer: resumeCareers.map((career) => ({
                id: 'resumeCareers_' + career.code,
                label: career.codeName,
                value: career.code,
            })),

            ResumeCareerYear: [
                { value: '1', option: '1년' },
                { value: '2', option: '2년' },
                { value: '3', option: '3년' },
                { value: '4', option: '4년' },
                { value: '5', option: '5년' },
                { value: '6', option: '6년' },
                { value: '7', option: '7년' },
                { value: '8', option: '8년' },
                { value: '9', option: '9년' },
                { value: '10', option: '10년' },
                { value: '11', option: '11년' },
                { value: '12', option: '12년' },
                { value: '13', option: '13년' },
                { value: '14', option: '14년' },
                { value: '15', option: '15년' },
                { value: '16', option: '16년' },
                { value: '17', option: '17년' },
                { value: '18', option: '18년' },
                { value: '19', option: '19년' },
                { value: '20', option: '20년' },
                { value: '21', option: '21년' },
                { value: '22', option: '22년' },
                { value: '23', option: '23년' },
                { value: '24', option: '24년' },
                { value: '25', option: '25년' },
                { value: '26', option: '26년' },
                { value: '27', option: '27년' },
                { value: '28', option: '28년' },
                { value: '29', option: '29년' },
                { value: '30', option: '30년' },
            ],
        };
        return options[name];
    };

    // dropdown
    const handleOptionChange = (selectedValue, name) => {
        switch (name) {
            case 'size':
                setSize(selectedValue);
                break;
            case 'sortBy':
                setSortBy(selectedValue);
                break;
            // case 'conditionSearch':
            //     setConditionSearch(selectedValue);
            //     break;
            default:
                setCheckedValues((checkedValues) => getDropdownValue(checkedValues, name, selectedValue));
                break;
        }
    };

    // select box, radio box
    const handleInputChange = (code) => {
        setCheckedValues({ ResumeCareer: [code] });
    };

    // get label
    const getCheckedLabels = () => {
        const labels = [];

        // lấy label từ checkedValues
        Object.entries(checkedValues).forEach(([key, values]) => {
            const options = getOptions(key);
            if (!options) return;

            const valueArray = Array.isArray(values) ? values : [values];
            valueArray.forEach((value) => {
                const matchedOption = options?.find((option) => option.value === value);
                if (matchedOption) {
                    if (key === 'ResumeCareer' && value === '009') {
                        labels.push(`경력`);
                    } else {
                        labels.push(matchedOption.option || matchedOption.label); // Dùng option nếu có
                    }
                }
            });
        });

        // lấy label từ resumeRegion
        Object.entries(resumeRegion).forEach(([regionSiCode, regionGuCodes]) => {
            const regionSi = resumeProvinces.find((province) => province.code === regionSiCode); // Lấy tên RegionSi từ resumeProvinces

            if (regionSi) {
                regionGuCodes.forEach((regionGuCode) => {
                    const commune = resumeCommunes[regionSiCode]?.find((commune) => commune.code === regionGuCode); // Tìm commune
                    if (commune) {
                        labels.push(`${regionSi.codeName} > ${commune.codeName}`);
                    }
                });
            }
        });

        if (keywords && keywords.length > 0) {
            keywords.forEach((keyword) => {
                labels.push(keyword);
            });
        }

        return labels;
    };

    // remove label
    const handleRemoveLabel = (label) => {
        setCheckedValues((prevValues) => {
            const newValues = { ...prevValues };
            // duyệt qua các key trong checkedValues
            Object.entries(newValues).forEach(([key, values]) => {
                const options = getOptions(key);

                // xử lý xóa ResumeCareer với giá trị '경력'
                if (key === 'ResumeCareer' && label.startsWith('경력:')) {
                    // xóa expMin và expMax khi label là dạng 경력: X ~ Y
                    delete newValues.ExpMin;
                    delete newValues.ExpMax;
                    delete newValues[key];
                    return;
                }

                // xử lý các giá trị khác
                if (!options) return;

                // tìm value tương ứng với label
                const matchedOption = options.find((option) => option.label === label);
                if (matchedOption) {
                    if (Array.isArray(values)) {
                        // nếu là mảng (checkbox), loại bỏ giá trị tương ứng
                        newValues[key] = values.filter((value) => value !== matchedOption.value);
                        if (newValues[key].length === 0) {
                            delete newValues[key];
                        }
                    } else if (values === matchedOption.value) {
                        // nếu là giá trị đơn (radio, select), đặt lại giá trị
                        delete newValues[key];
                    }
                }
            });
            return newValues;
        });

        setResumeRegion((prevValues) => {
            const newValues = { ...prevValues };

            const [regionSiName, regionGuName] = label.split(' > ');

            const regionSi = resumeProvinces.find((province) => province.codeName === regionSiName);
            const regionSiCode = regionSi ? regionSi.code : null;

            let regionGuCode = null;
            if (regionSiCode) {
                const regionGu = resumeCommunes[regionSiCode]?.find((commune) => commune.codeName === regionGuName);
                if (regionGu) {
                    regionGuCode = regionGu.code;
                }
            }

            if (regionSiCode && regionGuCode) {
                if (newValues[regionSiCode]) {
                    newValues[regionSiCode] = newValues[regionSiCode].filter((code) => code !== regionGuCode);

                    if (newValues[regionSiCode].length === 0) {
                        delete newValues[regionSiCode];
                    }
                }
            }

            return newValues;
        });

        // xóa khỏi keywords và các trường 'Title', 'ResumeContent'
        const isKeywordLabel = label && keywords.includes(label); // kiểm tra có trong keywords list không

        if (isKeywordLabel) {
            // xóa keyword khỏi `keywords` state
            const keywordToRemove = label;

            setKeywords((prevKeywords) => {
                return prevKeywords.filter((keyword) => keyword !== keywordToRemove);
            });
        }

        // xóa label khỏi danh sách `checkedLabels`
        setCheckedLabels((prevLabels) => prevLabels.filter((l) => l !== label));
    };

    useEffect(() => {
        if (loggedIn) {
            dispatch(fetchInitialConditions());
        }
    }, [dispatch, loggedIn]);

    const handleSaveConditions = () => {
        if (window.location.pathname !== '/login' && window.location.pathname !== '/' && !loggedIn) {
            if (window.confirm(`회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`)) {
                navigate('/login');
            } else {
                alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                navigate('/');
            }
            return;
        }
        const savedDate = moment().format('YYYY/MM/DD');
        if (
            Object.keys(checkedValues).length === 0 &&
            Object.keys(resumeRegion).length === 0 &&
            checkedLabels.length === 0
        )
            return;

        const currentConditions = store.getState().PAFAA010.savedPAFAA010Conditions;
        if (currentConditions.length >= 5) {
            window.alert('저장가능한 개수는 5개 입니다.');
            return;
        }

        dispatch(
            saveFilterPAFAA010Conditions({
                resumeRegion,
                checkedValues,
                savedDate,
                checkedLabels,
            }),
        );

        dispatch(saveMatchingConditions(decode.seq));

        window.alert(MESSAGE.notify.saveSuccess);
    };

    const handleResetConditions = () => {
        setCheckedValues({});
        setCheckedLabels([]);
        setKeywords([]);
        setResumeRegion({});
    };

    useEffect(() => {
        setCheckedLabels(getCheckedLabels);
        // eslint-disable-next-line
    }, [checkedValues, resumeClass]);

    useEffect(() => {
        getPAFAA010search()
            .then(({ data }) => {
                setResumeProvinces(data.resumeProvinces);
                setResumeCommunes(data.resumeCommunes);
                setResumeClass(data.resumeClass);
                setResumeLicenses(data.resumeLicense);
                setResumeForms(data.resumeForm);
                setResumePositions(data.resumePosition);
                setResumePays(data.resumePay);
                setResumeCareers(data.resumeCareer);
            })
            .catch((error) => console.log(error));

        getPAAAA010resume()
            .then(({ data }) => {
                setResumeBanner(data.resume);
                const listSeq = [data.resume?.map((item) => item.seq).join(',')].filter((seq) => seq).join(',');
                if (listSeq.toString() === '') return;
                putPAAAA010Banner(listSeq.toString())
                    .then()
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    }, []);

    const getListData = (currentPage = page) => {
        // if (!loggedIn || decode?.authorities === 'ROLE_P') {
        //     setLoading(false);
        //     setResults([]);
        //     return;
        // }
        setLoading(true);
        setResults([]);
        let options = Object.keys(checkedValues).length === 0 ? null : checkedValues;
        const region = Object.keys(resumeRegion).length === 0 ? null : resumeRegion;

        if (options && Array.isArray(options.RegionGu)) {
            const filteredRegionGu = options.RegionGu.filter((value) => {
                const numValue = parseInt(value);
                const isDivisibleBy100 = Number.isInteger(numValue) && numValue % 100 === 0;
                const endsWithZeros = value.endsWith('00');
                return !isDivisibleBy100 && !endsWithZeros;
            });

            if (filteredRegionGu.length === 0) {
                const { RegionGu, ...restOptions } = options;
                options = Object.keys(restOptions).length === 0 ? null : restOptions;
            } else {
                options = { ...options, RegionGu: filteredRegionGu };
            }
        }
        if (options && options.ResumeCareer) {
            const arr = options.ResumeCareer;
            if (Array.isArray(arr) && arr.length === 1 && arr[0] === "999") {
                delete options.ResumeCareer;
            }
        }

        postPAFAA010list({
            options,
            resumeRegion: region,
            size,
            page: currentPage,
            sortBy,
        })
            .then(({ data }) => {
                setResults(data.data.list);
                setPages(data.info);
                setDataConFig({
                    bannerConfig: data.data.bannerConfig,
                });
            })
            .catch((error) => console.log(error))
            .finally(() => {
                setLoading(false);
            });
    };

    const handleSearchClick = () => {
        setSearchParams({ ...searchParams, page: 1 });
        getListData(1);
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, size, sortBy]);

    const handleSelectSavedCondition = (index) => {
        const item = savedConditions[index];
        if (!item) return;

        const { resumeRegionStore, checkedStoreValues, checkedLikeRightStoreValues, checkedStoreLabels } = item;

        setCheckedValues(checkedStoreValues);
        setResumeRegion(resumeRegionStore);
        setCheckedLabels(checkedStoreLabels);

        const keywordSet = new Set();
        if (checkedLikeRightStoreValues && !checkedLikeRightStoreValues['ResumeClass']) {
            Object.values(checkedLikeRightStoreValues).forEach((keywords) => {
                keywords.forEach((keyword) => keywordSet.add(keyword));
            });
        }
        setKeywords([...keywordSet]);
    };

    const handleClickOutSidePopup = (e) => {
        if (popupRef.current && !popupRef.current.contains(e.target)) {
            setSavedConditionsPopup(false);
        }
    };

    useEffect(() => {
        if (savedConditionsPopup) {
            document.addEventListener('mousedown', handleClickOutSidePopup);
            return () => {
                document.removeEventListener('mousedown', handleClickOutSidePopup);
            };
        }
    }, [savedConditionsPopup]);

    return (
        <div id="content">
            <Nav menu={MENU_RESUME} />
            <div id="tabs-form" className="container">
                <div className="top-form">
                    <h2>경력별</h2>
                    <div ref={popupRef}>
                        <button
                            id="saved-conditions"
                            data-type="popup"
                            onClick={() => {
                                if (
                                    window.location.pathname !== '/login' &&
                                    window.location.pathname !== '/' &&
                                    !loggedIn
                                ) {
                                    if (
                                        window.confirm(
                                            `회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`,
                                        )
                                    ) {
                                        navigate('/login');
                                    } else {
                                        alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                                        navigate('/');
                                    }
                                }
                                setSavedConditionsPopup(!savedConditionsPopup);
                            }}
                        >
                            <span>저장한 조건 보기</span>
                            <i className="icon icon-down" />
                        </button>
                        <div className={`popup ${savedConditionsPopup ? 'active' : ''}`} htmlFor="saved-conditions">
                            <button
                                className="popup-close"
                                onClick={() => {
                                    setSavedConditionsPopup(false);
                                }}
                            />
                            <div className="popup-header">
                                최근 저장한 검색 조건<span>(보관은 최대 5개까지 가능)</span>
                            </div>
                            <div className="popup-content">
                                <ul className="table table-content">
                                    <li className="row-name-column">
                                        <div className="column start">검색조건</div>
                                        <div className="column start">검색일</div>
                                        <div className="column">삭제</div>
                                    </li>
                                    {savedConditions.map((item, index) => (
                                        <li key={index} onClick={() => handleSelectSavedCondition(index)}>
                                            <ul className="wrap-link">
                                                {item.checkedStoreLabels.map((label, index) => (
                                                    <li key={index}>{label}</li>
                                                ))}
                                            </ul>
                                            <span className="date">{item.savedStoreDate}</span>
                                            <button
                                                className="delete"
                                                onClick={() => {
                                                    dispatch(deleteFilterPAFAA010Conditions(index));
                                                    dispatch(saveMatchingConditions(decode.seq));
                                                }}
                                            >
                                                <i className="icon icon-trash"></i>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={`tab tabs-select tabs-select-bag tab-${resumeCareers && resumeCareers.length % 4 === 0 ? 4 : 5
                        }-item`}
                    style={{ border: '1px solid #333' }}
                >
                    <div className="wrap-select-plus-child">
                        <ul className="center">
                            {resumeCareers.map((item) => (
                                <li
                                    key={item.code}
                                    className={checkedValues['ResumeCareer']?.includes(item.code) ? 'active' : ''}
                                    onClick={() => handleInputChange(item.code)}
                                >
                                    {item.codeName}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="tab-select-results">
                    <ul className="results-area center">
                        {Array.isArray(checkedLabels) &&
                            checkedLabels.length > 0 &&
                            checkedLabels.map((label, index) => (
                                <li key={`results-area-flex-${index}`} className="results-area-flex">
                                    <>
                                        <div className="item-search">{label}</div>
                                        <span
                                            className="item-remove icon icon-x"
                                            onClick={() => handleRemoveLabel(label)}
                                        ></span>
                                    </>
                                    {/* {checkedValues?.ResumeCareer?.[0] !== '009' ? (
                                        <>
                                            <div className="item-search">{label}</div>
                                            <span
                                                className="item-remove icon icon-x"
                                                onClick={() => handleRemoveLabel(label)}
                                            ></span>
                                        </>
                                    ) : (
                                        <>
                                            <span style={{ marginLeft: '15px', color: '#000', fontSize: '16px' }}>
                                                (
                                            </span>
                                            <Dropdown
                                                className="resumeCareerYear"
                                                placeholder="경력기간선택"
                                                options={getOptions('ResumeCareerYear').filter(
                                                    (option) =>
                                                        parseInt(option.value, 10) <
                                                        parseInt(checkedValues?.expMax || '999', 10),
                                                )}
                                                name="ExpMin"
                                                onChange={handleOptionChange}
                                            />
                                            ~
                                            <Dropdown
                                                className="resumeCareerYear"
                                                placeholder="경력기간선택"
                                                options={getOptions('ResumeCareerYear').filter(
                                                    (option) =>
                                                        parseInt(option.value, 10) >
                                                        parseInt(checkedValues?.expMin || '0', 10),
                                                )}
                                                name="ExpMax"
                                                onChange={handleOptionChange}
                                            />
                                            <span style={{ color: '#000', fontSize: '16px' }}>)</span>
                                            <span
                                                className="item-remove icon icon-x dropDown"
                                                onClick={() => handleRemoveLabel(label)}
                                            ></span>
                                        </>
                                    )} */}
                                </li>
                            ))}
                    </ul>
                    <div className="wrap-option-search-block">
                        <button onClick={handleSearchClick}>
                            선택한 조건으로<span>검색하기</span>
                        </button>
                        <div className="wrap-option-search">
                            <div className="option-reset icon icon-reset" onClick={handleResetConditions}>
                                조건 초기화
                            </div>
                            <div className="option-save icon icon-pin" onClick={handleSaveConditions}>
                                조건 저장
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Content Table */}
            <div id="content-table">
                <div className="container">
                    <div className="wrap-table">
                        <div className="header-table-container">
                            <div className="top-table">
                                <div className="top-table-title">
                                    <h1>검색결과</h1>
                                    <span>Search Results 전체 {pages?.totalRow}건</span>
                                </div>
                                <div className="wrap-dropDown">
                                    <div className="dropDowns">
                                        <Dropdown
                                            placeholder=""
                                            options={[
                                                { value: 'Seq', option: '등록일순' },
                                                { value: 'ModDate', option: '업데이트순' },
                                            ]}
                                            name="sortBy"
                                            value={sortBy}
                                            onChange={handleOptionChange}
                                        />
                                        <Dropdown
                                            placeholder=""
                                            options={[
                                                { value: 50, option: '50개씩 보기' },
                                                { value: 80, option: '80개씩 보기' },
                                                { value: 100, option: '100개씩 보기' },
                                            ]}
                                            name="size"
                                            value={size}
                                            onChange={handleOptionChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className="table table-header table-results"
                                style={{ gridTemplateColumns: 'calc(100% - 22% - 13%) 22% 13%' }}
                            >
                                <div className="column column-1">제목</div>
                                <div className="column column-2">경력/형태/자격증</div>
                                <div className="column column-3">수정</div>
                            </div>
                        </div>
                        <ResumeList
                            loading={loading}
                            results={results}
                            setResumeList={setResults}
                            resumeBanner={resumeBanner}
                            page={page}
                            dataConFig={dataConFig}
                            detailUrl="list"
                        />
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAFAA015;
